import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

const STYLE_OPTIONS = [
  { value: 'minimal', id: 'minimal', label: 'Minimal / Modern' },
  { value: 'playful', id: 'playful', label: 'Fun / Playful' },
  { value: 'elegant', id: 'elegant', label: 'Elegant / Luxe' },
  { value: 'bold', id: 'bold', label: 'Bold / Colorful' },
  { value: 'trust-creative', id: 'trust-creative', label: 'I trust your creative direction' },
];

export const StyleSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 4: DESIGN STYLE & THEME</h3>

    <div>
      <Label htmlFor="theme" className="text-charcoal-ink">Theme or Inspiration *</Label>
      <Textarea
        id="theme"
        required
        value={formData.theme}
        onChange={(e) => set('theme', e.target.value)}
        className="bg-white border-stone-taupe/20 min-h-[100px]"
      />
    </div>

    <div>
      <Label htmlFor="colors" className="text-charcoal-ink">Color Preferences *</Label>
      <Input
        id="colors"
        required
        value={formData.colors}
        onChange={(e) => set('colors', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
    </div>

    <div>
      <Label className="text-charcoal-ink mb-3 block">Style Preference *</Label>
      <RadioGroup value={formData.style} onValueChange={(value) => set('style', value)}>
        {STYLE_OPTIONS.map((opt) => (
          <div key={opt.value} className="flex items-center space-x-2">
            <RadioGroupItem value={opt.value} id={opt.id} />
            <Label htmlFor={opt.id} className="text-charcoal-ink font-normal cursor-pointer">{opt.label}</Label>
          </div>
        ))}
      </RadioGroup>
    </div>

    <div>
      <Label htmlFor="specificElements" className="text-charcoal-ink">Are there any specific elements you'd like included?</Label>
      <Textarea
        id="specificElements"
        value={formData.specificElements}
        onChange={(e) => set('specificElements', e.target.value)}
        className="bg-white border-stone-taupe/20 min-h-[80px]"
        placeholder="e.g., florals, icons, patterns, symbols"
      />
    </div>
  </div>
);
